import { FunctionComponent } from "react";
import ImpersonationBanner from "../impersonationBanner/ImpersonationBanner";
import ImpersonationModal from "../impersonationModal/ImpersonationModal";
import useVendorImpersonation from "../../hooks/useVendorImpersonation";
import useImpersonationCookieWatcher from "../../hooks/useImpersonationCookieWatcher.hook";

interface ImpersonationProps {
  userRole: string | string[];
  vrm: string;
}

const Impersonation: FunctionComponent<ImpersonationProps> = ({
  userRole,
  vrm,
}) => {
  useVendorImpersonation(userRole);
  useImpersonationCookieWatcher();

  return (
    <>
      <ImpersonationBanner />
      <ImpersonationModal userRole={userRole} vrm={vrm} />
    </>
  );
};

export default Impersonation;
